var map = {
	"./digital-signage-img1.jpg": 492,
	"./digital-signage-img2.jpg": 493,
	"./digital-signage-img3.jpg": 494,
	"./digital-signage-img4.jpg": 495,
	"./digital-signage-img5.jpg": 496,
	"./digital-signage-img6.jpg": 497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 491;